import { loadStripe } from "@stripe/stripe-js";
import DialerTreeConfig from "@/app/config";
import { useState } from "react";
import { toast } from "sonner";
import { DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@radix-ui/react-dropdown-menu";
import { Button } from "@/components/ui/button";
import { Elements } from "@stripe/react-stripe-js";
import { SetupForm } from "@/components/pages/billing/SetupForm";

export function AddCard({ onSuccess }: { onSuccess?: () => void }) {
  const [setAsDefault, setSetAsDefault] = useState(true);
  const [showForm, setShowForm] = useState(false);

  const stripePromise = loadStripe(DialerTreeConfig.stripePublishableKey);

  const handleSuccess = () => {
    setShowForm(false);
    toast.success("Your payment method has been added successfully");
    onSuccess?.();
  };

  const options = {
    appearance: {
      theme: "stripe" as const,
    },
  };

  return (
    <div className="space-y-4">
      <DialogHeader>
        <DialogTitle>Add Payment Method</DialogTitle>
        <DialogDescription>Add a card to your account</DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        {!showForm ? (
          <>
            <div className="flex items-center space-x-2">
              <Checkbox
                id="default"
                checked={setAsDefault}
                onCheckedChange={(checked) => setSetAsDefault(checked === true)}
              />
              <Label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                Set as default payment method
              </Label>
            </div>
            <Button onClick={() => setShowForm(true)} className="w-full">
              Continue
            </Button>
          </>
        ) : (
          <Elements stripe={stripePromise} options={options}>
            <div className="space-y-4">
              <div className="flex items-center space-x-2">
                <Checkbox
                  id="default-form"
                  checked={setAsDefault}
                  onCheckedChange={(checked) => setSetAsDefault(checked === true)}
                />
                <Label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                  Set as default payment method
                </Label>
              </div>
              <SetupForm onSuccess={handleSuccess} setAsDefault={setAsDefault} />
              <Button variant="outline" onClick={() => setShowForm(false)} className="w-full">
                Cancel
              </Button>
            </div>
          </Elements>
        )}
      </div>
    </div>
  );
}
